// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },
        /**
         * Mobile menu toggle
         */
         __toggleMobileMenu: function() {
            const menuBtn = wntrTheme.body.find('.hamburger');
            const headerEl = wntrTheme.body.find('.header');
            const subMenuBtn = wntrTheme.body.find('.header__toggle-sub-menu');
            const menuHeading = wntrTheme.body.find('.link-heading a').first();

            menuBtn.on('click', function() {
                $(this).toggleClass('is-active');
                headerEl.toggleClass('active-header');
            });

            menuHeading.on('click', function(e) {
                e.preventDefault();
            });

            subMenuBtn.on('click', function() {
                $(this).toggleClass('is-active');
                $(this).closest('.menu-item').find('.sub-menu').toggleClass('is-active');
            });

        },
        /**
         * Menu current item
         */
         __currentMenuItem: function() {
            const secondaryNav = wntrTheme.body.find('.header__secondary-navigation');
            const currentMenuItem = secondaryNav.find('.current_page_item');
            const menuItemFirst = secondaryNav.find('.menu-item').first();

            if (wntrTheme.body.find(secondaryNav).length > 0 && currentMenuItem.length) {
                menuItemFirst.removeClass('default');
            }

        },
        /**
         * Important banner
         */
         __importantBannerToggle: function() {
            const importantBanner = wntrTheme.body.find('.important-message__banner');
            const bannerToggle = importantBanner.find('.close-banner');

            if (importantBanner.length) {
                bannerToggle.on('click', function() {
                    $(importantBanner).removeClass('visible');
                });
            }
        },
        /**
         * Initialize accordions
         */
        __initAccordions: () => {
            if (wntrTheme.body.find('.banner-accordion').length > 0) {
                $(".banner-accordion").each(function(i, el) {
                    new handorgel(el);
                });
            }
        },
    };
    $(document).ready(wntrTheme.init);
})(jQuery);